import SearchChildByParentID from './SearchChildByParentID';

export default SearchChildByParentID;
